import {collectQueryParams} from '../../utils/queryParams';
import {resolveQueryString} from '@/utils/stringUtils/stringUtils';
function getImage(interestImageMap: Record<string, string>): string {
  if (!interestImageMap) {
    return '';
  }

  const formattedInterest = interestFromParams();

  const image = interestImageMap[formattedInterest];
  if (!image) {
    return '';
  }
  return image;
}

function getTitle(interestTitleMap: Record<string, string>): string {
  if (!interestTitleMap) {
    return '';
  }

  const formattedInterest = interestFromParams();
  if (!formattedInterest) {
    return '';
  }

  const title = interestTitleMap[formattedInterest];
  if (!title) {
    return '';
  }
  return resolveQueryString(title);
}

function formatInterest(interest: string) {
  const formattedInterest = interest.trim().toLowerCase();

  if (formattedInterest.includes('_')) {
    const split = formattedInterest.split('_');
    return split[0];
  }

  return formattedInterest;
}

function interestFromParams(): string {
  const interest = collectQueryParams()['interest'];
  if (!interest) {
    return '';
  }

  return formatInterest(interest);
}

function calculateFontSize(
  text: string,
  containerWidth: number,
  baseFontSize: number,
  minFontSize: number,
) {
  const context = document.createElement('canvas').getContext('2d');
  let fontSize = baseFontSize;

  while (true) {
    context.font = `${fontSize}px sans-serif`;
    const textWidth = context.measureText(text).width;

    if (textWidth <= containerWidth || fontSize <= minFontSize) {
      break;
    }
    fontSize--;
  }

  return fontSize;
}

export const ImposedImageService = {
  getImage,
  getTitle,
  calculateFontSize,
};
